import React, {useCallback, useMemo} from 'react'
import {Flex} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import Chip from '../../../components/chip'
import useOcapiSite from '../../../hooks/useOcapiSite'
import {getProductFamilyImage} from '../../../utils/product-family-image'

const ChipRefinement = ({filter, toggleFilter, selectedFilters, value}) => {
    const selected = useMemo(() => selectedFilters?.includes(value.value), [selectedFilters, value])
    const onChange = useCallback(
        () => toggleFilter(value, filter.attributeId, selected, true),
        [value, filter.attributeId, selected, toggleFilter]
    )
    const {productFamilyImage} = useOcapiSite()

    const image = useMemo(() => {
        if (!!productFamilyImage && filter.attributeId === 'c_productFamily') {
            const img = getProductFamilyImage(productFamilyImage, value.label)
            if (!img) {
                return img
            }

            // add width to image
            const url = new URL(img)
            const query = new URLSearchParams(url.search)
            query.set('sw', '50')
            url.search = query.toString()
            return url.toString()
        }
        return null
    }, [filter.attributeId, productFamilyImage, value.label])

    return (
        <Chip
            name={value.label}
            {...(image ? {image: {link: image}} : null)}
            count={value.hitCount}
            orderable
            selected={selected}
            onChange={onChange}
            {...(filter.attributeId === 'c_productFamily' ? {variant: 'refinementChip'} : null)}
        />
    )
}

ChipRefinement.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array,
    value: PropTypes.object
}

const ChipRefinements = ({filter, toggleFilter, selectedFilters}) => {
    return (
        <Flex gap={3} wrap="wrap">
            {filter.values
                ?.filter((refinementValue) => refinementValue.hitCount > 0)
                .map((value) => (
                    <ChipRefinement
                        key={value.value}
                        filter={filter}
                        toggleFilter={toggleFilter}
                        selectedFilters={selectedFilters}
                        value={value}
                    />
                ))}
        </Flex>
    )
}

ChipRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default ChipRefinements
